export default "__VITE_ASSET__C61_mn5y__"